import { useNavigate, useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useAlert } from '../../../common/Context/AlertContext';
import { useLoader } from '../../../common/Context/LoaderContext';
import { ManageApis } from '../../../common/APIS/ManageApis';
import SubmitButton from '../../submitButton/SubmitButton';

function ConfirmEmail() {
  const [userMessage, setUserMessage] = useState('');
  const [searchParams] = useSearchParams();
  const { showAlert } = useAlert();
  const { setLoading } = useLoader();
  const navigate = useNavigate();
  const UserId = searchParams.get('userId');
  const Token = searchParams.get('token');
  // const Token = decodeURIComponent(TokenData).replace(/\s/g, '+');
  const ProductId = searchParams.get('productId');
  useEffect(() => {
    if (UserId && Token && ProductId) {
      confirmMail();
    } else {
      showAlert('User Id/Token/Product ID is Missing', {
        enableWarningIcon: true,
      });
    }
  }, []);

  const confirmMail = async () => {
    try {
      setLoading(true);
      let path = window.confirmEmail;
      let requestBody = {
        userId: UserId,
        token: Token,
        productId: ProductId,
      };

      const response = await ManageApis('post', path, requestBody);
      if (
        response?.status_code == 200 &&
        response?.response_data?.status == 'Success'
      ) {
        setUserMessage(response?.response_data?.message);
        //window.location.href = 'about:blank';
      } else {
        setUserMessage(response?.response_data?.message || response?.message);
      }
    } catch (error) {
      setUserMessage(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-100 h-100 d-flex align-items-center ">
      <div className="p-3 p-md-0  mx-auto registerMain">
        <div>
          <h3 className="text-center">
            {userMessage || 'Email is validating. Please wait....'}
          </h3>
        </div>
        <div className="d-flex justify-content-center">
          <SubmitButton
            style={{ marginTop: '0px' }}
            className="mt-0 rounded-pill"
            onClick={() => navigate('/login')}
            label="Login to continue"
          />
        </div>
      </div>
    </div>
  );
}

export default ConfirmEmail;
